import { render, staticRenderFns } from "./live-checkin.vue?vue&type=template&id=36335a45&lang=pug"
import script from "./live-checkin.vue?vue&type=script&lang=coffee"
export * from "./live-checkin.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports